
import React, { useEffect, useState } from 'react';

const SplashScreen: React.FC = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // 🚀 OTIMIZAÇÃO: Mostra conteúdo imediatamente
    setShowContent(true);
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background z-[99999]">
      <div className={`flex flex-col items-center transition-opacity duration-300 ${showContent ? 'opacity-100' : 'opacity-0'}`}>
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-sm text-foreground">Carregando...</p>
      </div>
    </div>
  );
};

export default SplashScreen; 